import { createContext, useState } from "react";
import merge from "lodash/merge";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

const SettingsContext = createContext({
  updateSettings: () => {},
  settings: MatxLayoutSettings
});

export const SettingsProvider = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(settings || MatxLayoutSettings);

  const handleUpdateSettings = (update = {}) => {
    const merged = merge({}, currentSettings, update);
    setCurrentSettings(merged);
  };

  return (
    <SettingsContext.Provider
      value={{ settings: currentSettings, updateSettings: handleUpdateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
